import { ModalBody, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import DateTimePickerField from 'components/forms/dateTimePickerField/DateTimePickerField';
import FormWithProvider from 'components/forms/form/Form';
import FormFieldset from 'components/forms/form/FormFieldset';
import TimezoneSelectField from 'components/forms/timezoneSelectField/TimezoneSelectField';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import { ScheduledMessage } from 'models/automation/ScheduledMessages';
import useFetchLeadForLeadCell from 'pages/automations/common/cells/lead/useFetchLeadForLeadCell';
import {
  getFormDefaultValues,
  scheduledMessagesRescheduleModalSchema,
} from './ScheduledMessagesRescheduleModal.schema';
import { ParagraphStyled } from './ScheduledMessagesRescheduleModal.styles';
import ScheduledMessagesRescheduleModalFooter from './ScheduledMessagesRescheduleModalFooter';
import useScheduledMessageRescheduleModalFormSubmit from './useScheduledMessageRescheduleModalFormSubmit';

interface ScheduledMessagesRescheduleModalProps {
  scheduledMessage: ScheduledMessage;
}

const ScheduledMessagesRescheduleModal = ({
  scheduledMessage,
}: ScheduledMessagesRescheduleModalProps) => {
  const { t } = useTranslation();

  const { lead, isFetching } = useFetchLeadForLeadCell({
    leadUid: scheduledMessage.leadUid,
  });

  const { onSubmit } = useScheduledMessageRescheduleModalFormSubmit({
    scheduledMessage,
  });

  if (isFetching) {
    return <LoadingPlaceholder />;
  }

  return (
    <FormWithProvider
      defaultValues={getFormDefaultValues({ lead, scheduledMessage })}
      onSubmit={onSubmit}
      resolver={scheduledMessagesRescheduleModalSchema()}
      noValidate
    >
      <FormFieldset>
        <ModalBody>
          <Row className="d-flex flex-column">
            <ParagraphStyled>
              {t(
                'pageAutomations.scheduledMessages.modalReschedule.description',
                {
                  name: scheduledMessage.messageName,
                  recipients:
                    scheduledMessage.triggerRecipients?.join(', ') ?? '-',
                },
              )}
            </ParagraphStyled>
            <TimezoneSelectField
              disabled
              label={t(
                'pageAutomations.scheduledMessages.modalReschedule.timezone',
              )}
              name="timezone"
            />
            <DateTimePickerField
              label={t(
                'pageAutomations.scheduledMessages.modalReschedule.date',
              )}
              name="date"
            />
            <DateTimePickerField
              label={t('common.time')}
              name="time"
              timeOnly
            />
          </Row>
        </ModalBody>
        <ScheduledMessagesRescheduleModalFooter />
      </FormFieldset>
    </FormWithProvider>
  );
};

export default ScheduledMessagesRescheduleModal;
